import { connect } from 'react-redux';

import EMailControl from './EMailControl';
import { RootState } from 'app/store/rootReducer';
import { getBulbMessage } from 'app/store/data/formsConfig';
import {
  DispatchToPropsInterface,
  EMailControlProps,
  StateToPropsInterface,
} from './EMailControl.interfaces';

const mapStateToProps = (state: RootState, props: EMailControlProps) => ({
  bulbInfoMessage: props.formName
    ? getBulbMessage(state, props.formName, props.questionKey)
    : undefined,
});

const mapDispatchToProps = () => ({});

const EMailControlContainer = connect<
  StateToPropsInterface,
  DispatchToPropsInterface
>(
  mapStateToProps,
  mapDispatchToProps
)(EMailControl);

export default EMailControlContainer;
